import { useQuery } from '@tanstack/react-query';

import * as workflowServices from 'services/workflow';

export const userWorkflowRolesKey = (userId) => [
  'user-workflow-roles',
  parseInt(userId, 10),
];

export function useUserWorkflowRoles({ id, ...options } = {}) {
  const { data } = useQuery({
    queryKey: userWorkflowRolesKey(id),
    enabled: !!id,
    queryFn: async () => {
      const res = await workflowServices.getUserWorkflowRolesService();
      if (!res?.isSuccess) {
        throw new Error(res?.message || 'Failed to load workflow roles');
      }
      return res?.data;
    },
    ...options,
  });

  return {
    workflowRoles: data?.workflowRoles || [],
  };
}
